

















































































































































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ReportReconStatementRow } from "../table-data/ReportReconStatementRow"
import { ReconStatementRowErrorReferences } from "../table-data/ReconStatementErrorReferencesRow"
import { Classificator } from "../../../common/types/Classificator"
import { Draggable } from "../../../common/types/Draggable"
import { Indicator } from "../../../common/types/Indicator"
import { ClassificationType, Segmentation } from "../../../common/types/roots/fields"
import { formatDigitsGrouping, padLeadingZeros } from "../../../common/utils/formattingUtils"
import { cloneDeep } from "lodash"
import axios from "axios";

type Column = keyof ReportReconStatementRow

interface TableField {
    key: Column
    active: boolean
}

interface ParentIndicator {
    key: string
    colspan: number
    rowspan: number
}


@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    },
    filters: {
        formatDate: function (value:any) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
})
export default class ReportReconStatement extends Vue {

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    public readonly tableData!: ReportReconStatementRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propIndicators!: Indicator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly incomes!: Classificator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]

    @Prop({
        type: String,
        required: true,
    })
    private readonly classificationType!: ClassificationType

    @Prop({
        type: Date,
        required: true,
        default: new Date(),
    })
    private readonly date!: Date

    @Prop({
        type: Boolean,
        required: true,
        default: false,
    })
    private readonly isTree!: boolean

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly segmentation!: Draggable<Segmentation>[]

    public tableFields: TableField[] = []
    public classifications: Classificator[] = []
    public indicators: Indicator[] = []

    public currentPage = 1
    public get visibleRows() {
        return this.tableData.filter(it => it.visible).length
    }
    public get currentItems(): ReportReconStatementRow[] {
        if (this.isTree) {
            return this.tableData.filter(it => it.visible)
        } else {
            const indexedPage = this.currentPage - 1
            const startIndex = indexedPage * 10
            const endIndex = startIndex + 10
            return this.tableData.filter(it => it.visible).slice(startIndex, endIndex)
        }
    }

    public parentIndicators: ParentIndicator[] = []

    public modalForm : boolean = false
    private currRefObject:any = {};
    private currentRefernceStatus:any = null;
    private references: ReconStatementRowErrorReferences[] = []
    private requestTypeOptions:any =  {
        "individual": {
            code: "individual",
            name_ru: "Внутренняя",
            name_kk: "Ішкі",
            name_en: "Internal"
        },
        "movement": {
            code: "movement",
            name_ru: "Передвижка",
            name_kk: "Қозғалыс",
            name_en: "Moving"
        },
        "budget_adjustment": {
            code: "budget_adjustment",
            name_ru: "Корректировка",
            name_kk: "Реттеу",
            name_en: "Correction"
        },
        "budget_clarification": {
            code: "budget_clarification",
            name_ru: "Уточнение",
            name_kk: "Түсіндіру",
            name_en: "Clarification"
        },
        "budget_income": {
            code: "budget_income",
            name_ru: "Поступления(скорректированные)",
            name_kk: "Кірістер (түзетілген)",
            name_en: "Receipts (adjusted)"
        },
        "budget_income_clarification": {
            code: "budget_income_clarification",
            name_ru: "Поступления(уточненные)",
            name_kk: "Кірістер (жаңартылған)",
            name_en: "Receipts (revised)"
        },
        "budget_income_movement": {
            code: "budget_income_movement",
            name_ru: "Поступления(передвижка)",
            name_kk: "Кірістер (қозғалыс)",
            name_en: "Receipts (transfer)"
        }
    }
    private larTableFields:any[] = [
        {
            key: 'number',
            label: 'Номер',
            thStyle: { width: "10%" },
        },
        {
            key: 'date',
            label: 'Дата согласования',
            thStyle: { width: "20%" },
        },
        {
            key: 'requestType',
            label: 'вид справки',
            thStyle: { width: "20%" },
        },
        {
            key: 'description',
            label: 'Основание',
            thStyle: { width: "60%" },
        }
    ]
    private async loadReferences(spfObj:ReportReconStatementRow) {
        this.currRefObject = spfObj
        const that = this
        const dif1:string|number|null    = spfObj.obaz_dif
        const dif2:string|number|null    = spfObj.plat_dif

        const difList:number[] = []
        if (typeof dif1 === "number" && dif1 !== 0) difList.push(dif1)
        if (typeof dif2 === "number" && dif2 !== 0) difList.push(dif2)
        let prg:any = spfObj.ref_prg
        let ppr:any = spfObj.ref_ppr
        let spf:any = spfObj.ref_spf
        if (!Number(prg).isNaN && spfObj.ref_prg) {
            prg = parseInt(spfObj.ref_prg)
        }
        if (!Number(ppr).isNaN && spfObj.ref_ppr) {
            ppr = parseInt(spfObj.ref_ppr)
        }
        if (!Number(spf).isNaN && spfObj.ref_spf) {
            spf = parseInt(spfObj.ref_spf)
        }
        const req:any = {
            year: this.date.getFullYear(),
            date: `${this.date.getFullYear()}-${this.date.getMonth() + 1}-${this.date.getDate()}`,
            gu: spfObj.ref_gu,
            prg: prg,
            ppr: ppr,
            spf: spf,
            dif_list: difList
        }
        await axios.post('/api-py/monitoring/reports-constructor/journal/recon-statement/error-references', req).then(resp => {
            if (resp.status === 200) {
                that.references = resp.data.ref_list;
                that.currentRefernceStatus = resp.data.query_index;
                that.modalForm = true;
            }
        }).catch(e => {

        })
    }

    private created() {
        this.indicators = cloneDeep(this.propIndicators)
        this.constructTableFields(true)
        this.handlePageChange(1)
    }

    private constructTableFields(isOnCreate: boolean) {
        // Классификаций
        if (this.isTree) {
            let classifications: Classificator[] = []
            if (this.classificationType === 'INCOMES') {
                classifications = cloneDeep(this.incomes)
            } else if (this.classificationType === 'EXPENSES') {
                classifications = cloneDeep(this.expenses)
            } else {
                throw new Error('error_type_classification')
            }
            let totalClassifications: Classificator[] = []
            this.segmentation.forEach((seg) => {
                if (seg.active) {
                    if (seg.value === 'REGION') {
                        totalClassifications.push({
                            key: 'region',
                            active: true,
                            selected: []
                        })
                    } else if (seg.value === 'GU') {
                        totalClassifications.push({
                            key: 'gu',
                            active: true,
                            selected: []
                        })
                    } else if (seg.value === 'KBK') {
                        totalClassifications = [...totalClassifications, ...classifications]
                    }
                }
            })
            const guIndex = totalClassifications.findIndex(item => item.key === 'gu');
            const segValues = this.segmentation.filter(seg => seg.active).map(seg => seg.value);
            const guSegIndex = segValues.indexOf('GU');
            if (guIndex !== -1 && guSegIndex !== 0 && guSegIndex !== segValues.length - 1) {
                const abpIndex = totalClassifications.findIndex(item => item.key === 'abp');
                if (abpIndex !== -1) {
                    const [guItem] = totalClassifications.splice(guIndex, 1);
                    totalClassifications.splice(abpIndex, 0, guItem);
                }
            }
            const activeClassifications = totalClassifications.filter(it => it.active)
            this.classifications = activeClassifications
        }

        // Показатели
        const tableFields: TableField[] = []
        const indicators = cloneDeep(isOnCreate ? this.propIndicators : this.indicators)
        indicators.filter(it => it.active).forEach(indicator => {
            tableFields.push({ key: (indicator.key as any), active: true })
        })

        // Родительские колонки
        const activeIndicators = indicators.filter(it => it.active).map(it => it.key)
        if (this.classificationType === 'INCOMES') {
            this.parentIndicators = this.constructIncomeParentIndicators(activeIndicators)
        } else {
            this.parentIndicators = this.constructExpenseParentIndicators(activeIndicators)
        }

        this.tableFields = tableFields
    }

    private constructIncomeParentIndicators(activeIndicators: string[]): ParentIndicator[] {
        const parentIndicators: ParentIndicator[] = []

        // Утвержденный бюджет на отчетный финансовый год

        // Уточненный бюджет
        let eaData = 0
        if (activeIndicators.find(key => key === 'god_ea')) {
            eaData++
        }
        if (activeIndicators.find(key => key === 'mes_ea')) {
            eaData++
        }
        if (eaData > 0) {
            parentIndicators.push({ key: 'data_ea', colspan: eaData, rowspan: 1 })
        }
        // Скорректированный бюджет
        let data127 = 0
        if (activeIndicators.find(key => key === 'god127')) {
            data127++
        }
        if (activeIndicators.find(key => key === 'mes127')) {
            data127++
        }
        if (data127 > 0) {
            parentIndicators.push({ key: 'data_127', colspan: data127, rowspan: 1 })
        }
        // Кассовое исполнение
        let deviation = 0
        if (activeIndicators.find(key => key === 'dev_god')) {
            deviation++
        }
        if (activeIndicators.find(key => key === 'dev_mes')) {
            deviation++
        }
        if (deviation > 0) {
            parentIndicators.push({ key: 'deviation', colspan: deviation, rowspan: 1 })
        }

        return parentIndicators
    }

    private constructExpenseParentIndicators(activeIndicators: string[]): ParentIndicator[] {
        const parentIndicators: ParentIndicator[] = []

        let data_420 = 0
        if (activeIndicators.find(key => key === 'plg')) {
            data_420++
        }
        if (activeIndicators.find(key => key === 'obaz')) {
            data_420++
        }
        if (activeIndicators.find(key => key === 'plat')) {
            data_420++
        }
        if (data_420 > 0) {
            parentIndicators.push({ key: 'data_420', colspan: data_420, rowspan: 1 })
        }
        let data_ea = 0
        if (activeIndicators.find(key => key === 'sum_oblig')) {
            data_ea++
        }
        if (activeIndicators.find(key => key === 'sum_payment')) {
            data_ea++
        }
        if (data_ea > 0) {
            parentIndicators.push({ key: 'data_ea', colspan: data_ea, rowspan: 1 })
        }
        let utchBudgetColspan = 0
        if (activeIndicators.find(key => key === 'obaz_dif')) {
            utchBudgetColspan++
        }
        if (activeIndicators.find(key => key === 'plat_dif')) {
            utchBudgetColspan++
        }
        if (utchBudgetColspan > 0) {
            parentIndicators.push({ key: 'deviation', colspan: utchBudgetColspan, rowspan: 1 })
        }

        // Утвержденный бюджет на отчетный финансовый год
        if (activeIndicators.find(key => key === 'is_equal')) {
            parentIndicators.push({ key: 'is_equal', colspan: 1, rowspan: 2 })
        }
        return parentIndicators
    }

    public handlePageChange(page: number) {
        this.currentPage = page
    }

    public tr(key: any): string | null {
        if (typeof key !== 'string') {
            return null
        }

        let text = ''
        let tableTranslationKey = ''
        if (this.classificationType === 'INCOMES') {
            tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.recon_statement_report.1_27.table'
        } else if (this.classificationType === 'EXPENSES') {
            tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.recon_statement_report.4_20.table'
        }
        text = String(this.$t(`${tableTranslationKey}.${key}`))

        if (!text || text === `${tableTranslationKey}.${key}`) {

            const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
            text = String(this.$t(`${translationKey}.${key}`))

            if (!text || text === `${translationKey}.${key}`) {
                text = key
            }
        }

        if (text.includes('$date')) {
            const formattedPreviousYearDate = `${this.date.getDate().toString().padStart(2, '0')}.${(this.date.getMonth() + 1).toString().padStart(2, '0')}.${this.date.getFullYear()}`
            text = text.replaceAll("$date", formattedPreviousYearDate)
        }

        return text
    }

    public synchronizeIndicatorsOrder() {
        // const fullIndicatorKeys = this.indicatorKeys.filter(it => ['plgp', 'plgo'].notIncludes(it)).concat(['plgs'])
        // const indicatorsOrder = this.tableFields
        //     .filter(it => fullIndicatorKeys.includes(it.key))
        //     .map(it => it.key)

        //     fullIndicatorKeys.forEach(indicatorKey => {
        //     if (indicatorsOrder.notIncludes(indicatorKey)) {
        //         indicatorsOrder.push(indicatorKey)
        //     }
        // })

        // const tempIndicators: Indicator[] = []
        // indicatorsOrder.forEach(indicatorKey => {
        //     const IndicatorObject = this.indicators.find(it => it.key === indicatorKey)!
        //     tempIndicators.push(IndicatorObject)
        // })

        // this.indicators = tempIndicators
        // this.$emit('update-indicators', tempIndicators)
    }

    public synchronizeVisiblityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.constructTableFields(false)
    }

    public format(value: any): any {
        if (value == null) {
            return ''
        }
        if (Number(value).isNaN) {
            if (typeof value === 'string') {
                return this.tr(value)
            }
            return value
        }
        return formatDigitsGrouping(value)
    }
    public padLeft = padLeadingZeros

    public tableCollapse = true
    public collapse(idx:number, collapse:boolean, collapseAll:boolean = false) {
        const el:ReportReconStatementRow = this.tableData[idx]
        if (el.hasChild) {
            for (const ch of this.tableData.slice(idx + 1)) {
                if (ch.parent_idx === idx)  {
                    ch.visible = !collapse
                    if (collapse || collapseAll) {
                        this.collapse(ch['idx'], collapse, collapseAll)
                        ch.collapse = collapse
                    }
                }

            }
        }
        el.collapse = collapse
    }
    public collapseAll(collapse:boolean) {
        for (const item of this.tableData) {
            if (item.parent_idx === null && item.hasChild) {
                item.collapse = collapse
                this.collapse(item.idx, collapse, true)
            }
        }
        this.tableCollapse = collapse
    }
}
